// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bLj9V","left":"styles_left__3NVjI","desktopActions":"styles_desktopActions__3KpvI","title":"styles_title__28Cvr"};